import { Popover } from "antd";
import { JSX, ReactNode } from "react";
interface Props {
  isDisabled: boolean;
  children: ReactNode;
  content?: ReactNode;
}

export function DisabledPopover({
  isDisabled,
  children,
  content,
}: Props): JSX.Element {
  if (!isDisabled) {
    if (!children) return <></>;
    return children as JSX.Element;
  }
  return (
    <Popover
      content={content || "You do not have permission to take this action"}
      trigger={["hover", "click"]}
    >
      <div>{children}</div>
    </Popover>
  ) as JSX.Element;
}
